<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">ПО устройств/OC</div>
            <a class="title-block__btn btn-add btn-primary btn" :href="route_create_page">Добавить</a>
        </div>
    </div>

    <table-element :actions="actions" :thead="thead" :tbody="tbody" @editItem="update"></table-element>
    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>

<script>

import TableElement from '../../../../elements/TableElement.vue';
import PaginationElement from '../../../../elements/PaginationElement.vue';
import DeviceSoftware from '../../../../models/DeviceSoftware';
import ChangePage from '../../../../helpers/ChangePage';

export default {
    name: 'DeviceSoftwareComponent',
    components: {
        TableElement,
        PaginationElement,
    },
    props: {
        route_create_page: String,
        route_edit_page: String,
        route_list: String,
        current_page: {
            type: Number,
            default: 1
        }
    },
    data: function () {
        return {
            deviceSoftware: new DeviceSoftware({
                route_list: this.route_list,
            }),
            search: '',
            actions: [
                {
                    text: 'Редактировать',
                    emit: 'editItem',
                    svg: `<button class="table-action table-action_edit m-auto align-middle" title="Редактировать"></button>`
                },
            ],
            thead: [
                'Название'
            ],
            tbody: [],
            count: 1,
            limit: 30,
            page: 1,
        }
    },
    methods: {
        loadTable: async function () {
            let response = await this.deviceSoftware.loadTable(this.page, this.limit, this.search);
            this.tbody = response.tbody;
            this.count = response.pages;
            if(this.page > 1 && this.tbody.length === 0)
            {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.loadTable();
        },
        update: function (params) {
            window.location.href = this.route_edit_page + params.id;
        }
    },
    mounted() {
        this.loadTable();
    }
}
</script>

<style scoped>

</style>
